import { cn } from '@/lib/utils';
import { formatarData } from '@/lib/mare-utils';
import type { DiaMareInterpretado } from '@/types/mare';

interface MareTableProps {
  dias: DiaMareInterpretado[];
  t: (key: string) => string;
  mesRef: number;
  diaRef: number;
}

export function MareTable({ dias, t, mesRef, diaRef }: MareTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <caption className="sr-only">{t('widget.mare.tableCaption')}</caption>
        <thead>
          <tr className="border-b border-sand-200">
            <th scope="col" className="text-left py-2 px-3 font-body text-xs font-semibold text-warm-gray">
              {t('widget.mare.colData')}
            </th>
            <th scope="col" className="text-left py-2 px-3 font-body text-xs font-semibold text-warm-gray">
              {t('widget.mare.colMareAlta')}
            </th>
            <th scope="col" className="text-left py-2 px-3 font-body text-xs font-semibold text-warm-gray">
              {t('widget.mare.colMareBaixa')}
            </th>
            <th scope="col" className="text-left py-2 px-3 font-body text-xs font-semibold text-warm-gray">
              {t('widget.mare.colStatus')}
            </th>
          </tr>
        </thead>
        <tbody>
          {dias.map((d, i) => (
            <tr
              key={`${d.dia}-${d.mes}`}
              className={cn(
                'border-b border-sand-100',
                i === 0 && 'bg-ocean-50/40'
              )}
            >
              <td className="py-3 px-3 font-body text-sm text-warm-dark whitespace-nowrap">
                {formatarData(d.dia, d.mes, d.ano, t)}
                {d.dia === diaRef && d.mes === mesRef && (
                  <span className="ml-2 text-[10px] bg-ocean text-white px-1.5 py-0.5 rounded font-medium">
                    {t('widget.mare.todayBadge')}
                  </span>
                )}
              </td>
              <td className="py-3 px-3 font-body text-sm text-warm-dark">
                {d.mareAlta.map(m => `${m.hora} (${m.altura}m)`).join(', ')}
              </td>
              <td className="py-3 px-3 font-body text-sm text-warm-dark">
                {d.mareBaixa.map(m => `${m.hora} (${m.altura}m)`).join(', ')}
              </td>
              <td className="py-3 px-3 font-body text-sm">
                <span aria-label={d.label} title={d.label}>
                  {d.badge}{' '}
                  <span className="hidden sm:inline text-warm-dark">{d.label}</span>
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
